import { VBox } from "../../common/components/ui/VBox";

export class LobbyFeaturePanel extends VBox {
    public override alignmentStrategy(): void {
        const componentWidth = this.width;
        let positionY = 0.0;
        for (let i = 0; i < this.children.length; i++) {
            let child = this.children[i];
            const childBounds = child.getLocalBounds();
            child.position.y = positionY;
            child.position.x = (componentWidth - childBounds.width * child.scale.x) * 0.5;
            positionY += child.visible ? childBounds.height * child.scale.y + this.childSpacing : 0;
        }
    }
}